export class User {
    id?: string;
    email: string = '';
    password: string = '';
    firstName?: string;
    lastName?: string;
    avatar: string = '';
    locale?: string;
    role?: string;
    has_accepted_terms: string = '0';
    companyName?: string;
    isInitialized?: string;
    uid?: string;
    token?: string;
}
